<div v-if="options">
	<time-panel :event="options.event"></time-panel>
</div>
